import * as React from "react";
const SvgFiRrImageSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-image-slash_svg__a)">
      <path
        fill="#062147"
        d="M18 8a2 2 0 1 1-3.999.001 2 2 0 0 1 4 0m5.707 15.707a.997.997 0 0 1-1.414 0l-22-22A.999.999 0 1 1 1.707.293L3.243 1.83A5 5 0 0 1 6 1h12c2.757 0 5 2.243 5 5v12c0 .987-.29 1.944-.829 2.757l1.536 1.536a1 1 0 0 1 0 1.414m-19-20.414 16 16c.191-.4.293-.842.293-1.293V6c0-1.654-1.346-3-3-3H6c-.45 0-.892.102-1.293.293M17 21H6a3 3 0 0 1-2.974-2.612l4.681-4.68a.999.999 0 1 0-1.414-1.415L3 15.586V7a1 1 0 1 0-2 0v11c0 2.757 2.243 5 5 5h11a1 1 0 1 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-image-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrImageSlash;
